import React from "react";
import PropTypes from "prop-types";
import { colors } from "Constants/colorConstants";

const WarningTriangleFilled = props => {
  return (
    <svg
      width={props.width}
      height={props.width}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.69182 14.7362C1.01918 15.9854 1.92394 17.5001 3.3427 17.5001H16.6572C18.0759 17.5001 18.9807 15.9854 18.308 14.7362L11.6508 2.37278C10.9429 1.05803 9.05699 1.05803 8.34905 2.37278L1.69182 14.7362Z"
        fill={props.fill}
      />
      <path
        d="M10 6.25C9.65482 6.25 9.375 6.52982 9.375 6.875V10.625C9.375 10.9702 9.65482 11.25 10 11.25C10.3452 11.25 10.625 10.9702 10.625 10.625V6.875C10.625 6.52982 10.3452 6.25 10 6.25Z"
        fill="white"
      />
      <path
        d="M10 12.5C10.5178 12.5 10.9375 12.9197 10.9375 13.4375C10.9375 13.9553 10.5178 14.375 10 14.375C9.48223 14.375 9.0625 13.9553 9.0625 13.4375C9.0625 12.9197 9.48223 12.5 10 12.5Z"
        fill="white"
      />
    </svg>
  );
};

WarningTriangleFilled.defaultProps = {
  height: 20,
  width: 20,
  fill: colors.surfaceOnError,
};

WarningTriangleFilled.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number,
  fill: PropTypes.string,
};

export default WarningTriangleFilled;
